import React, { useState } from "react";
import { Box, Button, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { AsyncProductAutocomplete } from "../../../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import { ProductForSelection } from "../../../../../components/Forms/AsyncAutocomplete/Product/AutcompleteProductTypes";
import { useDialog } from "../Dialogs";
import _ from "lodash";
import { DisplayableProduct } from "../../../../../store/api/upsellApi";

function AddProductsDialog({
  onAdd,
  allowMultiple,
  menuSalesareaId,
}: {
  onAdd: (p: ProductForSelection[]) => void;
  allowMultiple: boolean;
  menuSalesareaId: number;
}) {
  const [products, setProducts] = useState<ProductForSelection[]>([]);

  return (
    <Box sx={{ width: "480px" }}>
      <DialogTitle>Add a product</DialogTitle>
      <DialogContent>
        <AsyncProductAutocomplete
          async_url={`core/producten/search?fields=id,id as value,snaam as label,vestiging_id,naam,snaam,id,sortkey,is_actief,blocked,prijs&sort_field=naam&sort_dir=asc&vestiging_id=${menuSalesareaId}`}
          multiple={allowMultiple}
          onChange={(newProduct): void => {
            if (newProduct) {
              if (_.isArray(newProduct)) {
                setProducts(newProduct);
              } else {
                setProducts([newProduct]);
              }
            } else {
              setProducts([]);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color={"success"}
          disabled={products.length === 0}
          onClick={() => {
            onAdd(products);
          }}
          variant={"contained"}
        >
          Add
        </Button>
      </DialogActions>
    </Box>
  );
}

export const NO_PRODUCT_SELECTED = Symbol("No product selected");

export default function useAddProducts({
  allowMultiple,
  menuSalesareaId,
}: {
  allowMultiple: boolean;
  menuSalesareaId: number;
}) {
  const { createDialog, closeDialog } = useDialog();

  return () => {
    return new Promise<DisplayableProduct[] | typeof NO_PRODUCT_SELECTED>((resolve, reject) => {
      createDialog({
        afterClosing: () => {},
        onClose: () => {
          resolve(NO_PRODUCT_SELECTED);
          closeDialog("select-product-dialog");
        },
        name: "select-product-dialog",
        children: (
          <AddProductsDialog
            allowMultiple={allowMultiple}
            menuSalesareaId={menuSalesareaId}
            onAdd={function (products) {
              resolve(
                products.map((p) => ({
                  id: p.id,
                  name: p.naam,
                  system_name: p.snaam,
                  price: p.prijs,
                  active: p.is_actief,
                  blocked: p.blocked,
                }))
              );
              closeDialog("select-product-dialog");
            }}
          />
        ),
      });
    });
  };
}
